import { handleActions } from 'redux-actions';

import actions from '../actions/app/actions';

export const name = 'app';

// as far as the server is concerned, the app is always online
const isServer = !globalThis.navigator;
const isOnline = !isServer && navigator.onLine;
const hasBeenOffline = !isServer && !navigator.onLine;

const initialState = {
  drawer: null,
  hasBeenOffline,
  isOnline,
  isPageLoading: false,
  overlay: false,
  pending: {},
  searchOpen: false,
  nextRootComponent: null,
  headerOnTop: true,
  mobileFilterBarFixedOnTop: false,
  headerToolbarHeight: 0,
  headerHeight: 0,
  activeColumn: null,
  cartActiveColumn: null,
};

const reducerMap = {
  [actions.toggleDrawer]: (state, { payload }) => {
    return {
      ...state,
      drawer: payload,
      overlay: !!payload,
    };
  },
  [actions.toggleSearch]: state => {
    return {
      ...state,
      searchOpen: !state.searchOpen,
    };
  },
  [actions.setOnline]: state => {
    return {
      ...state,
      isOnline: true,
    };
  },
  [actions.setOffline]: state => {
    return {
      ...state,
      isOnline: false,
      hasBeenOffline: true,
    };
  },
  [actions.setPageLoading]: (state, { payload }) => {
    return {
      ...state,
      isPageLoading: !!payload,
    };
  },
  [actions.setNextRootComponent]: (state, { payload }) => {
    return {
      ...state,
      nextRootComponent: payload,
    };
  },
  [actions.toggleHeaderOnTop]: (state, { payload }) => {
    return {
      ...state,
      headerOnTop: payload,
    };
  },
  [actions.setHeaderToolbarHeight]: (state, { payload }) => {
    return {
      ...state,
      headerToolbarHeight: payload,
    };
  },
  [actions.setMobileFilterBarFixedOnTop]: (state, { payload }) => {
    return {
      ...state,
      mobileFilterBarFixedOnTop: payload,
    };
  },
  [actions.setHeaderHeight]: (state, { payload }) => {
    return {
      ...state,
      headerHeight: payload,
    };
  },
  [actions.setActiveColumn]: (state, { payload }) => {
    return {
      ...state,
      activeColumn: payload,
    };
  },
  [actions.setCartActiveColumn]: (state, { payload }) => {
    return {
      ...state,
      cartActiveColumn: payload,
    };
  },
};

export default handleActions(reducerMap, initialState);
